function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/*------------------------------------------------------------------
Import modules
------------------------------------------------------------------*/

import { ajax, serialize, offset } from 'meteora';
import { FormValidation, ReCaptchaValidation } from '../classes/validation';

/*------------------------------------------------------------------
Page Setup
------------------------------------------------------------------*/

_toConsumableArray(document.querySelectorAll('.js-contact-page')).forEach(function (page) {
  // Note: page is actually a block now :)
  var XHR = new XMLHttpRequest();
  var form = page.querySelector('form');
  var map = page.querySelector('.js-contact-page__map');
  if (map) {
    // Here because google maps is dumb
    window.GoogleMapsLoaded = function () {};
    var loadAPI = function loadAPI() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return new Promise(function (resolve, reject) {
        // Load the google maps api
        var script = document.createElement('script');
        script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(key, "&callback=GoogleMapsLoaded");
        script.async = true;
        script.defer = true;
        script.addEventListener('load', function () {
          return resolve();
        });
        document.body.appendChild(script);
      });
    };
    loadAPI('AIzaSyCxpzSgupAehpTgRDkhfyOWk2i6Cgk9r8Q').then(function () {
      var MapController = new google.maps.Map(map, {
        center: {
          lat: window.ContactPage.location.lat || 0,
          lng: window.ContactPage.location.lng || 0
        },
        zoom: 15
        // disableDefaultUI: true,
      });

      var marker = new google.maps.Marker({
        position: {
          lat: window.ContactPage.location.lat || 0,
          lng: window.ContactPage.location.lng || 0
        },
        map: MapController
      });

      // Prevent the marker from opening the info window
      marker.addListener('click', function () {
        marker.setAnimation(google.maps.Animation.BOUNCE);
        setTimeout(function () {
          marker.setAnimation(null);

          // Open a link to the location in google maps
          setTimeout(function () {
            window.open("https://www.google.com/maps/search/?api=1&query=".concat(window.ContactPage.location.lat, ",").concat(window.ContactPage.location.lng), '_blank');
          }, 750);
        }, 750);
      });
    });
  }
  if (form) {
    // Set up a new validator
    var Validation = new FormValidation(form);
    // Set up new ReCaptcha validation
    var ReCaptcha = new ReCaptchaValidation(form.querySelector('.g-recaptcha'));
    // Grab the submit button
    var action = form.querySelector('[type="submit"]');

    // Here we handle the submition functionality
    Validation.on('submit', function () {
      // Send the form using the XHR
      XHR.open('POST', form.action);
      XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

      // Set the request header to be ajax
      XHR.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      XHR.send(serialize(form));
      XHR.onload = function () {
        try {
          var response = JSON.parse(XHR.responseText);
          try {
            dataLayer.push({
              'form_type': 'Contact_Form',
              'message_id': response.data.data.ID,
              'event': 'form_submission'
            });
          } catch (err) {
            console.log(err);
          }

          // Prepend a form message
          if (response.message) {
            // Create a new p tag
            var message = document.createElement('div');
            // Add the message
            message.innerHTML = response.message;
            // Add the class
            message.className = 'message success';
            // Add the p tag to the form
            form.insertBefore(message, form.firstChild);
          }
        } catch (err) {
          // Give the form a new style
          form.classList.add('submitted');
        }

        // Reset the form and validation
        Validation.reset();
        // Scroll to the success message
        window.ScrollController.scrollTo(offset(form).y - 200);
      };
    });

    // Set up what happens after form validation
    Validation.on('validate', function (validity) {
      var captcha = ReCaptcha.validate();
      // If the form is valid, and recaptcha is valid, then submit it
      if (validity && captcha) {
        Validation.submit();
      } else if (Validation.invalid.length) {
        Validation.invalid[0].element.focus();
        window.ScrollController.scrollTo(offset(Validation.invalid[0].element).y - 200);
      }
    });
    ReCaptcha.on('validate', function (valid) {
      ReCaptcha.field.classList.toggle('recaptcha-error', !valid);
    });

    // When we submit the form, we need to validate it, then submit it via ajax
    action.addEventListener('click', function (e) {
      e.preventDefault();

      // Abort the XHR if it's already running
      if (XHR.readyState !== 4) XHR.abort();
      Validation.validate();
    });
  }
});